import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import SerialTrack from "./components/SerialTrack";
import CategorySection from "./components/CategorySection";
import LatestUpdate from "./components/LatestUpdate";
import Record from "./components/Record";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { faqs } from "../../mocks/trendData";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 grid h-11 w-11 cursor-pointer place-items-center rounded-full bg-primary-500 text-white shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </button>
  );
}

export default function Home() {
  useEffect(() => {
    document.title =
      "吃瓜合集 - 娱乐热点连续剧瓜全程追踪 · 系列爆料时间线整理";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute(
      "content",
      "吃瓜合集专注娱乐热点与事件追踪，把连续剧瓜、系列爆料的全程时间线整理成串，事件全记录持续更新，顺着时间线吃瓜不遗漏，老板吃瓜更省心。"
    );

    const upsertScript = (id: string, data: object) => {
      let el = document.getElementById(id) as HTMLScriptElement | null;
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    };

    upsertScript("ld-org", {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "吃瓜合集",
      url: "https://guoaichuan.cn/",
      description:
        "专注娱乐热点与事件追踪的内容平台，整理连续剧瓜与系列爆料的完整时间线。",
    });

    upsertScript("ld-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <HotRank />
        <SerialTrack />
        <CategorySection />
        <LatestUpdate />
        <Record />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}